import script from "./PersonAddressComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./PersonAddressComponent.vue?vue&type=script&setup=true&lang=ts"

import "./PersonAddressComponent.vue?vue&type=style&index=0&id=0606e708&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0606e708"]])

export default __exports__